// new tagging, @see https://docs.google.com/document/d/1Tzpf6Z0tahdFu27C_QiIi02eAnVv4zA7S1VMS-UCbCs/edit#heading=h.1et4itury42

import BattedBallType from "./BattedBallType.js";

const TaggingData = {
    IsBunt: { key: 'IS_BUNT', name: 'Bunt', short: 'Bunt', type: 'BOOL', description: 'A BUNT is a batted ball not swung at, but intentionally met with the bat and tapped slowly within the infield.' },

    'BattedBallType': { key: 'BATTED_BALL_TYPE', name: 'Batted Ball Type', short: 'Type', type: 'STRING', enum: BattedBallType, enumDefault: BattedBallType.Unidentified.key, description: 'Defines type of batted ball based on trajectory shape.' },
    
    BallInDirt: { key: 'BALL_IN_DIRT', name: 'Ball In Dirt', short: 'Dirt', type: 'BOOL', description: '"Ball in the dirt" is a ball that is badly thrown (usually by the pitcher) which is thrown into the dirt (at the feet of the catcher or baseman, for example).' },
    // TODO - add more...
};

export default TaggingData;